import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { T } from "../../constants";

/* ---------- Contracted-lot chips (click to expand inventory) ---------- */

const useStyles = makeStyles({
  bar: { display: "flex", flexWrap: "wrap", alignItems: "center", gap: 8 },
  legend: { fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, color: T.fg },
  chip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    borderRadius: 8,
    padding: "8px 12px",
    fontSize: 13,
    cursor: "pointer",
    fontFamily: "inherit",
    transition: "background .15s ease, border-color .15s ease",
  },
  name: { fontWeight: 600, color: T.fg },
  sep: { color: T.subtleFg },
  strong: { fontWeight: 600, color: T.fg },
  muted: { color: T.mutedFg },
  caret: { color: T.subtleFg },
  toggleBtn: {
    borderRadius: 8,
    border: `1px solid ${T.border}`,
    background: T.elevated,
    color: T.fg,
    fontWeight: 600,
    padding: "8px 12px",
    fontSize: 13,
    cursor: "pointer",
    fontFamily: "inherit",
  },
});

export default function LotBar({ lots, expandedLot, onToggle, toggleLabel, onToggleMore }) {
  const s = useStyles();
  return (
    <div className={s.bar}>
      <span className={s.legend}>Lots</span>
      {lots.map((lot) => {
        const remaining = lot.available == null ? "-" : lot.available;
        const isOpen = expandedLot === lot.id;
        const typeLabel = lot.type === "OFFSITE" ? "Off-site" : "On-site";

        return (
          <button
            key={lot.id}
            onClick={() => onToggle(isOpen ? null : lot.id)}
            className={s.chip}
            style={{
              border: `1px solid ${isOpen ? T.primary : T.border}`,
              background: isOpen ? T.accent : T.elevated,
            }}
          >
            <span className={s.name}>{lot.name}</span>
            <span className={s.sep}>-</span>
            <span className={s.strong}>{remaining}</span>
            <span className={s.muted}>
              left - {lot.occupied} occupied - {typeLabel}
            </span>
            <span className={s.caret}>{isOpen ? "v" : ">"}</span>
          </button>
        );
      })}
      {onToggleMore ? (
        <button type="button" className={s.toggleBtn} onClick={onToggleMore}>
          {toggleLabel}
        </button>
      ) : null}
    </div>
  );
}
